@if (tabsContent$ | async; as tabsContent) {
  @let insuranceClaimModel = insuranceClaim();

  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
    [destroyOnHide]="false"
    (activeIdChange)="onActiveIdChangeSaveCurrent($event)"
  >
    <li [ngbNavItem]="0">
      <button ngbNavLink class="nav-link" translate>
        INSURANCE_CLAIM_TABS_DOCUMENTS
      </button>
      <ng-template ngbNavContent>
        <app-insurance-claim-details-documents
          [insuranceClaimId]="insuranceClaimModel.id"
          [insuranceClaimUniqueId]="insuranceClaimModel.uniqueId"
          [contactId]="insuranceClaimModel.contactId"
        />
      </ng-template>
    </li>

    @for (
      tabContent of tabsContent; track tabContent.index; let count = $count; let isLast = $last) {
      <li
        [ngbNavItem]="tabContent.index"
      >
        <button ngbNavLink class="nav-link" translate>
          {{ tabContent.title }}
        </button>
        <ng-template ngbNavContent>
          <ng-container *ngComponentOutlet="tabContent.component" />
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
}
